import { isValidEndpointKey } from '../../http/EndpointKey';
import { HttpResponseActionTypes } from './action-types';
import { HttpStatus } from './types';
export const initialHttpResponsesState = {
  statuses: {},
  responses: {}
};

const httpResponsesReducer = (state = initialHttpResponsesState, action) => {
  if (!isValidEndpointKey(action.endpointKey)) {
    return state;
  }

  switch (action.type) {
    case HttpResponseActionTypes.RequestFetch:
      return Object.assign({}, state, {
        statuses: Object.assign({}, state.statuses, {
          [action.endpointKey]: HttpStatus.Fetching
        })
      });

    case HttpResponseActionTypes.Success:
      return Object.assign({}, state, {
        responses: Object.assign({}, state.responses, {
          [action.endpointKey]: action.response
        }),
        statuses: Object.assign({}, state.statuses, {
          [action.endpointKey]: HttpStatus.Success
        })
      });

    case HttpResponseActionTypes.Error:
      return Object.assign({}, state, {
        responses: Object.assign({}, state.responses, {
          [action.endpointKey]: action.error
        }),
        statuses: Object.assign({}, state.statuses, {
          [action.endpointKey]: HttpStatus.Error
        })
      });

    default:
      return state;
  }
};

export default httpResponsesReducer;